import React, { PropsWithChildren } from "react";
import classNames from "classnames";

import "./gradient-text.scss";

type GradientTextProps = PropsWithChildren<{
	tagName?: React.ElementType;
	gradient?:
	"--gradient-sherbet"
	| "--gradient-sherbet-2"
	| "--gradient-sherbet-3"
	| "--gradient-seabreeze"
	| "--gradient-pina-colada"
	| "--gradient-sunset"
	| "--gradient-sunrise"
	| "--gradient-sunset-light"
	| "--gradient-watermelon"
	| "--gradient-blue-razz"
	| "--gradient-blue-razz-light";
	/**
	 * for "as-one-element" to work properly with multiple children, the elements need to be display inline.
	 * For example:
	 *  ```
	 * <div style={{ display: 'inline-block' }}>one</div><div style={{ display: 'inline-block' }}>two</div>
	 * ```
	 * 
	 * */
	target?: 'as-one-element' | 'each-element';
	className?: string;
	displayChildren?: "inline-block" | "inline-flex";
	includeSVG?: boolean;
	onClick?: Function;
}>

const GradientText = (props: GradientTextProps) => {
	const {
		tagName,
		gradient = "--gradient-sunrise",
		target = 'as-one-element',
		className = '',
		displayChildren = '',
		onClick
	} = props;
	const Tag = tagName || "div";

	return (
		<Tag
			className={
				classNames(
					"gradient-text",
					target,
					className,
					displayChildren,
				)
			}
			style={{
				"--gradientTextGradient": `var(${gradient})`,
			}}
			onClick={onClick}
		>
			{props.children}
		</Tag>
	);
};

export default GradientText;
